import axios from 'axios';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { setDropDownStyle } from '../CommonHelper';

const ArticleTypesModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);

    let initialData = {
        Sn: 0,
        Type: '',
        Status: 1
    };

    const [articleTypeData, setArticleTypeData] = useState(initialData);

    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setArticleTypeData({ Sn: item.Sn, Type: item.Type, Status: item.Status });
            } else {
                setArticleTypeData(initialData);
            }
            setModalBox(true);
        }
    }));

    const handleSaveType = () => {
        if (articleTypeData.Type.trim().length === 0) {
            toast.error("Please Enter Article Type");
            return;
        }

        const endpoint = !articleTypeData.Sn ? '/createArticleType' : `/updateArticleType/${articleTypeData.Sn}`;
        axios.post(BACKEND_SERVER_URL + endpoint, articleTypeData)
            .then((response) => {
                toast.success(response.data.message);
                props.setArticleTypeLoading(!props.loadArticleTypes);
                setModalBox(false);
            }).catch(error => {
                console.log(error);
                toast.error(error.response?.data?.message || "Error saving Article Type");
            });
    }

    useEffect(() => {
        if (!modalBox) {
            setArticleTypeData(initialData);
        }
    }, [modalBox]);

    return (
        <Modal onHide={() => setModalBox(false)} show={modalBox} size="md" backdrop="static" keyboard={false}>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">{articleTypeData.Sn ? "Update Article Type" : "Add Article Type"}</h5>
                    <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                </div>
                <div className="modal-body">
                    <div className="mb-3">
                        <label className="form-label text-primary">Article Type<span className="required">*</span></label>
                        <input autoFocus className='form-control' type="text" value={articleTypeData.Type}
                            onChange={(e) => setArticleTypeData({ ...articleTypeData, Type: e.target.value })} />
                    </div>
                    <div className="mb-3">
                        <label className="form-label text-primary">Status<span className="required">*</span></label>
                        <Select
                            value={{ value: articleTypeData.Status, label: articleTypeData.Status == 1 ? "Active" : "Inactive" }}
                            onChange={(selectedOption) => setArticleTypeData({ ...articleTypeData, Status: selectedOption.value })}
                            options={[
                                { value: 1, label: "Active" },
                                { value: 0, label: "Inactive" }
                            ]}
                            styles={setDropDownStyle()}
                        />
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                    <button type="button" className="btn btn-primary btn-xs " onClick={handleSaveType}>
                        {articleTypeData.Sn ? "Update" : "Add "}
                    </button>
                </div>
            </div>
        </Modal>
    );
});

export default ArticleTypesModal;
